$(function () {

    if ($('#list_ind_fee').children().length == 0) {
        $('#res_ind_heading').hide();
    }

    if ($('#list_int_fee').children().length == 0) {
        $('#res_int_heading').hide();
    }

    if ($('#child_admission').children().length == 0) {
        $('#admssn_heading').hide();
    }


    if ($('#child_additional').children().length == 0) {
        $('#key_diff').hide();
    }

    if ($('#child_gallery').children().length == 1) {
        $('#section-1').hide();
    }
    if ($('#child_awards').children().length == 0) {
        $('#section-7').hide();
    }

    if ($('#child_leader').children().length == 0) {
        $('#leader_section').hide();
    }
    if (($('#list_ind_fee').children().length == 0) && $('#list_int_fee').children().length == 0) {

        $('#section-2').hide();
    }


    if ($('.fb_widget').children().length == 0) {
        $('.fb_widget').addClass('height_unset');
    }

    if ($('#child_boarding').children().length == 0) {
        $('#boarding_facilities').hide();
    }
    if ($('#child_cocurricular').children().length == 0) {
        $('#co-curr').hide();
    }
    if ($('#graphChild').children().length == 0) {
        $('#graph').hide();
    }

    if ($('#graph10total').children().length == 0) {
        $('#graph10heading').hide();
    }

    if ($('#graph12total').children().length == 0) {
        $('#graph12heading').hide();
    }

    if ($('#graph12total2').children().length == 0) {
        $('#graph12heading2').hide();
    }

    if ($('#graph10total2').children().length == 0) {
        $('#graph10heading2').hide();
    }

    if (($('#graph10total2').children().length == 0) && ($('#graph10total').children().length == 0)) {

        $('#graph10block').remove();

    }
    if (($('#graph12total2').children().length == 0) && ($('#graph12total').children().length == 0)) {

        $('#graph12block').remove();

    }

    if ($('#graphChild').children().length == 0) {
        $('#graph').hide();
    }


})
;


